import type { Version } from '@sunrise-ui/api/cerebro/api';
import { Platform } from '@sunrise-ui/api/cerebro/api';
import { isIos } from '@sunrise-ui/primitives';
import { compareVersions } from 'compare-versions';
import * as Application from 'expo-application';

export function getVersionInfo(versions: Version[]) {
  // Retrieve the current app version from expo-application
  const currentVersion = Application.nativeApplicationVersion;

  if (!currentVersion) {
    console.error('Could not retrieve app version.');
    return { isSupported: true, isOnLatest: true };
  }

  const platform = isIos ? Platform.Ios : Platform.Android;
  const platformVersions = versions.filter(
    (version: Version) => version.platform === platform,
  );

  const sortedVersionStrings = platformVersions
    .map((v) => v.version)
    .sort(compareVersions);
  const latestVersion = sortedVersionStrings[sortedVersionStrings.length - 1];

  const isExactMatch = sortedVersionStrings.includes(currentVersion);
  const isNewerThanLatest =
    latestVersion && compareVersions(currentVersion, latestVersion) > 0;

  return {
    isSupported: isExactMatch || isNewerThanLatest,
    isOnLatest: latestVersion === currentVersion || isNewerThanLatest,
  };
}
